<template>
    <div class="reg-temp-content-area main-content-height p-3">
        <div class="superadmin-dashboard-area edit-area">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-8">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <div class="edit-profle-wrapper text-left">
                                        <div class="user-avatar-wrapper">
                                            <div class="loading-overlay" v-if="uploading_file">
                                                <loading :message="'Please wait...'" />
                                            </div>

                                            <img v-if="vg_auth.avatar" :src="vg_auth.avatar" />
                                            <img v-else src="@/assets/images/user.png" alt="user" />
                                            <div class="edit-avatar-wrapper">
                                                <template v-if="attachment.name">
                                                    <span class="new-attachment-name" v-if="attachment.name">{{ attachment.name }} </span>
                                                </template>
                                                <label for="avatarAttachment" class="btn-default-rounded btn btn-secondary change-avatar">
                                                    <input
                                                        type="file"
                                                        ref="attachment"
                                                        @change="fileChange"
                                                        name="avatarAttachment"
                                                        id="avatarAttachment"
                                                    />
                                                    CHANGE AVATAR
                                                </label>
                                                <template v-if="attachment.name">
                                                    <button class="btn btn-primary update-avatar btn-default-rounded" @click.prevent="updateAvatar()">
                                                        UPDATE
                                                    </button>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-12 col-md-8 col-lg-8">
                                    <div class="edit-profle-wrapper text-left">
                                        <!-- <h3 class="mb-3 mt-3">Your Detail</h3> -->

                                        <p v-if="vg_auth.role != 'customer'">
                                            <label>Company:</label>
                                            <input class="baseline-input" type="text" id="company" v-model="form.company" />
                                        </p>

                                        <p>
                                            <label>First Name:</label>
                                            <input class="baseline-input" type="text" id="fname" v-model="form.fname" />
                                        </p>
                                        <p>
                                            <label>Last Name:</label>
                                            <input class="baseline-input" type="text" id="lname" v-model="form.lname" />
                                        </p>

                                        <div class="mb-3">
                                            <label>Address: <em class="notice">( please select the address from suggestion )</em></label>
                                            <!-- <input class="baseline-input" type="text" id="address" v-model="form.address" /> -->
                                            <span>
                                                <gmap-autocomplete
                                                    id="profile_address"
                                                    autocomplete="nope"
                                                    class="baseline-input"
                                                    large
                                                    name="address"
                                                    placeholder="your address..."
                                                    :select-first-on-enter="true"
                                                    :componentRestrictions="{country: ['ZA']}"
                                                    @place_changed="setPlace"
                                                    @keyup="resetPlace"
                                                >
                                                </gmap-autocomplete>
                                            </span>
                                            <div class="address-info-wrap" v-if="form.address && form.addressDetail && form.addressDetail.province">
                                                <p class="address-info"><span>Province:</span> {{ form.addressDetail.province }}</p>
                                                <p class="address-info"><span>City:</span> {{ form.addressDetail.city }}</p>
                                                <p class="address-info"><span>Suburb:</span> {{ form.addressDetail.suburb }}</p>
                                                <p class="address-info"><span>Postcode:</span> {{ form.addressDetail.postcode }}</p>
                                            </div>
                                        </div>

                                        <p>
                                            <label>Complex / Building + unit:</label>
                                            <input
                                                class="baseline-input"
                                                type="text"
                                                id="complex_building_unit"
                                                placeholder="Building/Complex + unit"
                                                v-model="form.complex_building_unit"
                                            />
                                        </p>

                                        <div v-if="vg_auth.role == 'reseller'">
                                            <div class="mb-3 mt-3">
                                                <div>
                                                    <p class="mb-0">Has website?</p>
                                                    <div class="form-check form-check-inline">
                                                        <input
                                                            v-model.number="form.has_website"
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="haveWebsite"
                                                            id="website_yes"
                                                            value="1"
                                                        />
                                                        <label class="form-check-label" for="website_yes">Yes</label>
                                                    </div>
                                                    <div class="form-check form-check-inline">
                                                        <input
                                                            v-model.number="form.has_website"
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="haveWebsite"
                                                            id="website_no"
                                                            value="0"
                                                        />
                                                        <label class="form-check-label" for="website_no">No</label>
                                                    </div>
                                                </div>
                                                <div v-if="form.has_website == 1" class="website-holder">
                                                    <span class="website-prefix dark">https://</span>
                                                    <input type="text" v-model="form.website" placeholder="eg: example.com" class="form-control" />
                                                </div>
                                            </div>
                                            <!--                                     
                                            <label>Website:</label>
                                            <input class="baseline-input" type="text" id="website" v-model="form.website" /> -->
                                        </div>

                                        <p>
                                            <label>Mobile:</label>
                                            <input class="baseline-input" type="text" id="mobile" v-model="form.mobile" />
                                        </p>
                                        <p v-if="vg_auth.role != 'customer'">
                                            <label>Region:</label>
                                            <select v-model="form.region" class="baseline-input">
                                                <option value="">--Select--</option>
                                                <option :value="region" v-bind:key="region" v-for="region in regions">{{ region }}</option>
                                            </select>
                                        </p>

                                        <div v-if="vg_auth.role == 'reseller'">
                                            <p>
                                                <label>Your distributor:</label>
                                                <select v-model="form.buy_product_from" class="baseline-input">
                                                    <option value="">--Select--</option>
                                                    <option
                                                        :value="distributor.id"
                                                        v-bind:key="distributor.company + distributor.id"
                                                        v-for="distributor in distributors"
                                                        >{{ distributor.company }}</option
                                                    >
                                                </select>
                                            </p>

                                            <p>
                                                <label>Reseller Type:</label>
                                                <select v-model="form.reseller_type" class="baseline-input">
                                                    <option value="">--Select--</option>
                                                    <option
                                                        :value="resellerType.value"
                                                        v-bind:key="resellerType.value"
                                                        v-for="resellerType in resellerTypes"
                                                        >{{ resellerType.label }}</option
                                                    >
                                                </select>
                                            </p>
                                        </div>

                                        <div v-if="vg_auth.role == 'distributor'">
                                            <p>
                                                <label>Depot Technician <em style="font-size:11px">Email address separated by "," comma</em></label>
                                                <input
                                                    class="baseline-input"
                                                    name="ccem"
                                                    v-model="form.tech_emails"
                                                    type="text"
                                                    autocomplete="new-em"
                                                    id="cc_em"
                                                />
                                            </p>
                                        </div>
                                        <p>
                                            <button @click.prevent="updateProfile()" class="btn btn-default-rounded btn-primary px-5">Submit</button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 col-md-12 col-lg-4">
                    <div class="card">
                        <div class="card-body">
                            <div class="pa-3">
                                <h5 class="mb-4">Reset Password</h5>
                                <p>
                                    <label>Current Password:</label>
                                    <input class="baseline-input" type="password" id="company" v-model="password.old" />
                                </p>
                                <p>
                                    <label>New Password:</label>
                                    <input class="baseline-input" type="password" id="company" v-model="password.new" />
                                </p>
                                <p>
                                    <label>Confirm New Password:</label>
                                    <input class="baseline-input" type="password" id="company" v-model="password.new_confirm" />
                                </p>
                                <p>
                                    <button @click.prevent="updatePassword()" class="btn-default-rounded btn btn-primary px-5">Update</button>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="card mt-3">
                        <div class="card-body">
                            <div class="pa-3">
                                <h5 class="mb-4">Change Email</h5>

                                <template v-if="newEmail.sentToken">
                                    <p style="font-size: 13px; line-height: 17px;" class="text-primary">
                                        <em
                                            >We have sent <b>verification code</b> in your email address (<b style="color:#000">{{
                                                newEmail.email
                                            }}</b
                                            >), Use that code here and click on <b>SUBMIT</b>.</em
                                        >
                                    </p>
                                    <p>
                                        <label>Verification Code:</label>
                                        <input name="newEmailToken" class="baseline-input" type="text" id="newEmailToken" v-model="newEmail.token" />
                                    </p>

                                    <p class="d-flex justify-content-between">
                                        <button @click.prevent="cancelUpdateEmail()" class="btn-default-rounded btn btn-secondary px-3">
                                            CANCEL
                                        </button>
                                        <button @click.prevent="changeEmail()" class="btn-default-rounded btn btn-primary px-3">SUBMIT</button>
                                    </p>
                                </template>

                                <template v-else>
                                    <p>
                                        <label>New Email:</label>
                                        <input name="newemail" class="baseline-input" type="text" id="newemail" v-model="newEmail.email" />
                                    </p>

                                    <p>
                                        <button @click.prevent="sendEmailChangeVerificationCode()" class="btn-default-rounded btn btn-primary px-5">
                                            Continue
                                        </button>
                                    </p>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Env from '@/env';
import {mapGetters, mapActions} from 'vuex';
import AuthApis from '@/controllers/AuthApis';
import Helpers from '@/helpers/index';

export default {
    name: 'EditProfile',
    data() {
        return {
            newEmail: {
                email: '',
                sentToken: false,
                token: ''
            },
            uploading_file: false,
            attachment: {
                data: '',
                name: '',
                type: '',
                size: ''
            },
            password: {
                old: '',
                new: '',
                new_confirm: ''
            },
            form: {
                fname: '',
                lname: '',
                address: '',
                website: '',
                has_website: 0,
                addressDetail: {
                    province: '',
                    city: '',
                    suburb: '',
                    postcode: '',
                    lat: '',
                    lng: ''
                },
                complex_building_unit: '',
                company: '',
                mobile: '',
                region: '',
                buy_product_from: null,
                tech_emails: '',
                reseller_type: ''
            },
            distributors: []
        };
    },

    computed: {
        regions() {
            return Env.regions;
        },
        resellerTypes() {
            return Env.resellerTypes;
        },
        ...mapGetters({
            vg_auth: 'auth/user'
        })
    },
    async mounted() {
        if (this.vg_auth) {
            this.form = {
                fname: this.vg_auth.fname,
                lname: this.vg_auth.lname,
                address: this.vg_auth.address,
                company: this.vg_auth.company,
                mobile: this.vg_auth.mobile,
                region: this.vg_auth.region,
                buy_product_from: this.vg_auth.buy_product_from,
                has_website: this.vg_auth.user_metas && this.vg_auth.user_metas.website ? this.vg_auth.user_metas.has_website : 0,
                website: this.vg_auth.user_metas && this.vg_auth.user_metas.website ? this.vg_auth.user_metas.website : '',
                complex_building_unit:
                    this.vg_auth.user_metas && this.vg_auth.user_metas.complex_building_unit ? this.vg_auth.user_metas.complex_building_unit : '',
                tech_emails: this.vg_auth.user_metas && this.vg_auth.user_metas.tech_emails ? this.vg_auth.user_metas.tech_emails : '',
                reseller_type: this.vg_auth.user_metas && this.vg_auth.user_metas.reseller_type ? this.vg_auth.user_metas.reseller_type : '',
                addressDetail: {
                    province: this.vg_auth.user_metas && this.vg_auth.user_metas.province ? this.vg_auth.user_metas.province : '',
                    city: this.vg_auth.user_metas && this.vg_auth.user_metas.city ? this.vg_auth.user_metas.city : '',
                    suburb: this.vg_auth.user_metas && this.vg_auth.user_metas.suburb ? this.vg_auth.user_metas.suburb : '',
                    postcode: this.vg_auth.user_metas && this.vg_auth.user_metas.postcode ? this.vg_auth.user_metas.postcode : '',
                    lat: this.vg_auth.user_metas && this.vg_auth.user_metas.lat ? this.vg_auth.user_metas.lat : '',
                    lng: this.vg_auth.user_metas && this.vg_auth.user_metas.lng ? this.vg_auth.user_metas.lng : ''
                }
            };
            this.$nextTick(() => {
                if (document.getElementById('profile_address')) {
                    document.getElementById('profile_address').value = this.vg_auth.address;
                }
            });

            if (this.vg_auth.role == 'reseller') {
                await this.fetchDistributors();
            }
        }
    },

    methods: {
        updatePassword() {
            const url = `${Env.baseUrl}/auth/update-password`;
            this.spinner(true);
            AuthApis.postApi(url, this.password)
                .then(async res => {
                    this.spinner(false);
                    this.password = Helpers.setObjValueEmpty(this.password);
                    return this.$toasted.global.success({
                        message: 'Successfully updated.'
                    });
                })
                .catch(err => {
                    this.$toasted.global.error({
                        message: err.response.data.errors[0]
                    });
                    this.spinner(false);
                });
        },

        async updateProfile() {
            // there must be lat , lng
            if (!this.form.addressDetail.lat && !this.form.addressDetail.lng) {
                return this.$toasted.global.error({
                    message: 'Please select one of the address from suggestion.'
                });
            }
            const url = `${Env.baseUrl}/auth/update-profile`;
            this.spinner(true);
            AuthApis.postApi(url, this.form)
                .then(async res => {
                    if (this.form.has_website != 1) {
                        this.form.website = '';
                    }
                    this.spinner(false);
                    await this.va_updateUserByKey(res.data.payload);
                    return this.$toasted.global.success({
                        message: 'Successfully updated.'
                    });
                })
                .catch(err => {
                    this.$toasted.global.error({
                        message: err.response.data.errors[0] ? err.response.data.errors[0] : 'Please try again later.'
                    });
                    this.spinner(false);
                });
        },

        /**
         * Fle handling
         */
        async fileChange(e) {
            let reader = new FileReader();
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }

            // file type cehck
            let acceptFile = ['image/jpg', 'image/jpeg', 'image/png'];
            if (acceptFile.indexOf(this.$refs.attachment.files[0].type) < -1) {
                document.getElementById('avatarAttachment').value = '';
                this.$toasted.global.error({
                    message: 'Only image files are allowed.'
                });
                return;
            }

            // filesize prevent
            let pic_limit_5Mb = 5 * 1000000; // 5 MB limit
            if (this.$refs.attachment.files[0].size > pic_limit_5Mb) {
                document.getElementById('avatarAttachment').value = '';
                this.$toasted.global.error({
                    message: 'Sorry file cannot be more than 5MB.'
                });
                return;
            }

            this.attachment = {
                file: files[0],
                name: this.$refs.attachment.files[0].name,
                type: this.$refs.attachment.files[0].type,
                size: this.$refs.attachment.files[0].size
            };
        },

        async updateAvatar() {
            let formData = new FormData();
            formData.append('attachment', this.attachment.file);
            this.uploading_file = true;
            const url = `${Env.baseUrl}/auth/update-avatar`;
            AuthApis.postApi(url, formData)
                .then(async res => {
                    this.uploading_file = false;
                    await this.va_updateUserByKey(res.data.payload);
                    this.attachment = {
                        data: '',
                        name: '',
                        type: '',
                        size: ''
                    };
                    document.getElementById('avatarAttachment').value = '';
                    this.$toasted.global.success({
                        message: 'success'
                    });
                })
                .catch(err => {
                    this.uploading_file = false;
                    this.$toasted.global.error({
                        message: err.response.data.errors[0]
                    });
                });
        },

        fetchDistributors() {
            // this is free route
            const url = `${Env.baseUrl}/get-distributors`;
            AuthApis.getApi(url)
                .then(res => {
                    this.distributors = res.data.payload;
                })
                .catch(err => {
                    console.log(err);
                });
        },

        /**
         * autocomplete set
         */
        setPlace: async function(addressData) {
            if (_.isEmpty(addressData)) {
                return;
            }
            // console.log(addressData.formatted_address)
            this.form.address = addressData.formatted_address;
            let province = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_1');
            let city = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_2');
            let suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_1');
            if (!suburb) {
                suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_2');
            }
            let postcode = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'postal_code');
            let {lat, lng} = Helpers.getLatLngFromGoogleAutoComplete(addressData);
            this.form.addressDetail = {
                province,
                city,
                suburb,
                postcode,
                lat,
                lng
            };
        },

        resetPlace: function() {
            this.form.address = '';
            this.form.addressDetail = {
                province: '',
                city: '',
                suburb: '',
                postcode: '',
                lat: '',
                lng: ''
            };
        },

        /**
         * Send update email confirmation code
         */
        sendEmailChangeVerificationCode() {
            if (this.newEmail.email == '') {
                this.$toasted.global.error({
                    message: 'Please add email.'
                });
            }
            let regexExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;
            if (!regexExp.test(this.newEmail.email)) {
                this.$toasted.global.error({
                    message: 'Invalid Email'
                });
            } else {
                const url = `${Env.baseUrl}/auth/update-profile-email-send-token`;
                this.spinner(true);
                AuthApis.postApi(url, this.newEmail)
                    .then(async () => {
                        this.spinner(false);
                        this.newEmail.sentToken = true;
                    })
                    .catch(err => {
                        this.$toasted.global.error({
                            message: err.response.data.errors[0] ? err.response.data.errors[0] : 'Please try again later.'
                        });
                        this.spinner(false);
                    });
            }
        },

        /**
         * change email
         */
        changeEmail() {
            const self = this;
            const url = `${Env.baseUrl}/auth/change-profile-email`;
            this.spinner(true);
            AuthApis.postApi(url, this.newEmail)
                .then(async () => {
                    this.spinner(false);
                    this.$toasted.global.success({
                        message: 'Email changed successfully. Please relogin.'
                    });

                    setTimeout(() => {
                        self.signOut();
                    }, 3000);
                })
                .catch(err => {
                    this.$toasted.global.error({
                        message: err.response.data.errors[0] ? err.response.data.errors[0] : 'Please try again later.'
                    });
                    this.spinner(false);
                });
        },

        /**
         * Cancel update email
         */
        cancelUpdateEmail() {
            this.newEmail.sentToken = false;
            this.newEmail.token = '';
        },

        async signOut() {
            this.logoutspinner(true);
            await this.va_logout();
            this.logoutspinner(false);
            this.$router.push({
                name: 'Login',
                query: {
                    refresh: true
                }
            });
            // window.location.reload();
        },

        ...mapActions({
            va_logout: 'clearAppData',
            va_updateUserByKey: 'auth/updateUserByKey'
        })
    }
};
</script>
